import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos Mendoza',
    role: 'Creador de Contenido',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    text: 'Pasé de tardar 3 días en editar un video a hacerlo en 45 minutos. Este sistema cambió mi vida como creador.',
    rating: 5
  }, {
    name: 'María González',
    role: 'Emprendedora Digital',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    text: 'Nunca pensé que podría crear videos virales sin mostrar mi cara. Ahora genero contenido todos los días.',
    rating: 5
  }, {
    name: 'Diego Ramírez',
    role: 'Coach Online',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    text: 'La inversión de $27 se pagó sola con mi primer cliente que llegó por un video viral. Increíble.',
    rating: 5
  }, {
    name: 'Ana Martínez',
    role: 'Marketing Digital',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
    text: 'El sistema es tan fácil de seguir que hasta mi equipo sin experiencia puede crear videos profesionales.',
    rating: 5
  }, {
    name: 'Luis Torres',
    role: 'Influencer',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    text: 'Mis videos ahora tienen 10x más alcance. La IA hace el trabajo pesado y yo solo superviso.',
    rating: 5
  }, {
    name: 'Sofia Ruiz',
    role: 'Consultora',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
    text: 'Lo mejor es que puedo crear contenido consistente sin quemar mi tiempo. Perfecto para escalar.',
    rating: 5
  }];
  return <section className="w-full px-4 py-16 md:py-20 bg-gradient-to-b from-purple-900/30 to-slate-900/50" data-id="element-372">
      <style data-id="element-373">
        {`
          @keyframes scrollTestimonials {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-400px * 6 - 1rem * 6));
            }
          }
          .animate-scroll-testimonials {
            animation: scrollTestimonials 30s linear infinite;
          }
        `}
      </style>
      <div className="max-w-6xl mx-auto" data-id="element-374">
        <div className="text-center mb-12" data-id="element-375">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/20 border border-purple-500/30 rounded-full mb-4" data-id="element-376">
            <StarIcon className="w-4 h-4 text-purple-300 fill-purple-300" data-id="element-377" />
            <span className="text-purple-200 text-sm font-medium" data-id="element-378">
              Lo Que Dicen Nuestros Usuarios
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-379">
            Testimonios Reales de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400" data-id="element-380">
              Creadores Como Tú
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-381">
            Más de 1,500 creadores ya están creando videos virales con IA
          </p>
        </div>
        <div className="overflow-hidden pb-4" data-id="element-382">
          <div className="flex gap-4 animate-scroll-testimonials" data-id="element-383">
            {[...testimonials, ...testimonials].map((testimonial, index) => <div key={index} className="flex-shrink-0 w-[400px] bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 backdrop-blur-sm" data-id="element-384">
                <div className="flex items-center gap-1 mb-4" data-id="element-385">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-386" />)}
                </div>
                <div className="mb-4" data-id="element-387">
                  <QuoteIcon className="w-8 h-8 text-purple-400/30 mb-2" data-id="element-388" />
                  <p className="text-gray-300 text-base leading-relaxed" data-id="element-389">
                    {testimonial.text}
                  </p>
                </div>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-700/50" data-id="element-390">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-391" />
                  <div data-id="element-392">
                    <p className="text-white font-semibold text-sm" data-id="element-393">
                      {testimonial.name}
                    </p>
                    <p className="text-gray-400 text-xs" data-id="element-394">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-395">
          <p className="text-gray-400 text-sm md:text-base" data-id="element-396">
            ⭐⭐⭐⭐⭐ Calificación promedio de 4.9/5 basada en más de 500
            reseñas
          </p>
        </div>
      </div>
    </section>;
}